
import howoften from "../../components/pages/blog/how-often-should-you-replace-your-mattress";

export default howoften;
